export function getCreatorInitials(creatorName) {
  const normalized = String(creatorName || '').trim();
  if (!normalized) return '?';

  const source = normalized.includes('@') ? normalized.split('@')[0] : normalized;
  const parts = source.replace(/[._-]+/g, ' ').split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
